import React from "react";
import { Card, Col, Empty, Row } from "antd";
import { Link } from "react-router-dom";
import { apiUrl } from "@utils/apoloClient";
import StrikethroughPrice from "@general/strikethroughPrice";

const UserMeetingRooms = ({ data }) => {
  if(!data)
  return (
<>
<Empty  description={"در حال حاضر پکیجی موجود نیست!!!"}/>
</>
);
  return (
    <>
      <Row
        gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 50]}
        justify="center"
        align="middle"
        style={{ height: "100%" }}
      >
        {data?.map((pack) => {
          const {
            id,
            name,
            amountRial,
            strikethroughRial,
            sessions,
            image,
            product,
          } = pack;
          return (
            <Col xl={6} lg={8} sm={12} xs={24} key={id}>
              <Link to={`/services/meeting-room-single/${id}`}>
                <Card
                  hoverable
                  className="package-card"
                  cover={
                    <img
                      alt="safatec"
                      src={`${apiUrl + image}`}
                      className="package-img"
                    />
                  }
                >
                  <h3 className="package-title">{name}</h3>
                  <span className="card-row">
                    <p>تعداد جلسات : </p> <span>{`${sessions} جلسه`}</span>
                  </span>
                  <span className="card-row">
                    <p>نوع اشتراک: </p> <span>{product?.name}</span>
                  </span>
                  <StrikethroughPrice
                    strikethroughRial={strikethroughRial}
                    amountRial={amountRial}
                  />
                </Card>
              </Link>
            </Col>
          );
        })}
      </Row>
    </>
  );

};

export default UserMeetingRooms;